"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.SelectableCardDefaultContent = void 0;
require("./SelectableCardDefaultContent.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * SelectableCardDefaultContent component
 *
 * @method
 * @param { SelectableCardDefaultContentProps } props
 * @returns SelectableCardDefaultContent
 */

const SelectableCardDefaultContent = props => {
  const {
    alignment = defaultProps.alignment,
    disabled = defaultProps.disabled,
    iconName,
    subTitle,
    subTitleTextColor = defaultProps.subTitleTextColor,
    subTitleTextStyle = defaultProps.subTitleTextStyle,
    supportingText,
    supportingTextColor = defaultProps.supportingTextColor,
    supportingTextStyle = defaultProps.supportingTextStyle,
    title,
    titleTextColor = defaultProps.titleTextColor,
    titleTextStyle = defaultProps.titleTextStyle
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-SelectableCardDefaultContent', {
    [`pal-c-SelectableCardDefaultContent__align--${alignment}`]: alignment,
    'pal-c-SelectableCardDefaultContent--disabled': disabled
  });
  return /*#__PURE__*/_react.default.createElement("span", {
    className: componentClassName
  }, iconName && /*#__PURE__*/_react.default.createElement("span", {
    className: "pal-c-SelectableCardDefaultContent__thumbnailContainer"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    disabled: disabled,
    name: iconName,
    size: "xl"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "pal-c-SelectableCardDefaultContent__textContainer"
  }, title && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textColor: disabled ? 'default-disabled' : titleTextColor,
    textStyle: titleTextStyle,
    textAlign: alignment,
    htmlTag: "span"
  }, title), subTitle && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textColor: disabled ? 'default-disabled' : subTitleTextColor,
    textStyle: subTitleTextStyle,
    textAlign: alignment,
    htmlTag: "span"
  }, subTitle), supportingText && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textColor: disabled ? 'default-disabled' : supportingTextColor,
    textStyle: supportingTextStyle,
    textAlign: alignment,
    htmlTag: "span"
  }, supportingText)));
};

/**
 * Property type definitions
 * @typedef SelectableCardDefaultContentProps
 * @type {object}
 * @property {string} alignment - Sets the card content alignment ( center or left )
 * @property {boolean} disabled - Sets the content disabled state
 * @property {string} iconName - Sets the name of the icon
 * @property {string} subTitle - Sets the subTitle text content
 * @property {string} subTitleTextColor - Sets the color of subTitle
 * @property {string} subTitleTextStyle - Sets the style of subTitle
 * @property {string} supportingText - Sets the supporting text content
 * @property {string} supportingTextColor - Sets the supporting text content color
 * @property {string} supportingTextStyle -  Sets the supporting text content style
 * @property {string} title - Sets the title text content
 * @property {string} titleTextColor - Sets the color of title
 * @property {string} titleTextStyle - Sets the style of title
 */
exports.SelectableCardDefaultContent = SelectableCardDefaultContent;
const propTypes = exports.propTypes = {
  /**
   * Sets the card content alignment
   */
  alignment: _propTypes.default.oneOf(['left', 'center']),
  /**
   * Sets the disabled state of the content
   */
  disabled: _propTypes.default.bool,
  /**
   * Sets the name of the icon
   */
  iconName: _propTypes.default.string,
  /**
   * Sets the second line subTitle text
   */
  subTitle: _propTypes.default.string,
  /**
   * Sets the color of the subTitle
   */
  subTitleTextColor: _propTypes.default.string,
  /**
   * Sets the style of subTitle
   */
  subTitleTextStyle: _propTypes.default.string,
  /**
   * Sets the content for supporting text
   */
  supportingText: _propTypes.default.string,
  /**
   * Sets the color of supporting text
   */
  supportingTextColor: _propTypes.default.string,
  /**
   * Sets the style of supporting text
   */
  supportingTextStyle: _propTypes.default.string,
  /**
   * Sets the title text
   */
  title: _propTypes.default.string,
  /**
   * Sets the color of the title
   */
  titleTextColor: _propTypes.default.string,
  /**
   * Sets the style of title
   */
  titleTextStyle: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} alignment='center' - Sets the default alignment of content to center
 * @property {boolean} disabled='false' -  Sets the default disabled state of content to false
 * @property {string} subTitleTextColor='default' - Sets the default subtitle color to default
 * @property {string} subTitleTextStyle='label' - Sets the default subtitle text style to label
 * @property {string} supportingTextColor='xsubtle' - Sets the default supporting text color to xsubtle
 * @property {string} supportingTextStyle='label-sm' - Sets the default supporting text style to label-sm
 * @property {string} titleTextColor='default' - Sets the default title color to default
 * @property {string} titleTextStyle='label' - Sets the default title text style to label
 */
const defaultProps = exports.defaultProps = {
  alignment: 'center',
  disabled: false,
  subTitleTextColor: 'default',
  subTitleTextStyle: 'label',
  supportingTextColor: 'xsubtle',
  supportingTextStyle: 'label-sm',
  titleTextColor: 'default',
  titleTextStyle: 'label'
};
SelectableCardDefaultContent.propTypes = propTypes;
var _default = exports.default = SelectableCardDefaultContent;